import { connect } from 'react-redux';
import LineGroups from '../components/LineGroups';
import { createLineGroup } from '../actions/linegroups';
import { createLine } from '../actions/line';
import { switchLineInSection } from '../actions/sections';

// function groupLines(state, lineIds) {
//   return lineIds
//     .map(altId => ({ line: state.song.lines.byId[altId], id: altId }))
//     .filter(x => x.line);
// }

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  linegroups: [
    ...Object.values(state.song.linegroups.byId).filter(grp => grp.lines.indexOf(ownProps.line.id) >= 0),
  ],
  line: ownProps.line,
  ui: state.ui,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  // onSelect: () => dispatch(selectItem('line', ownProps.line.id)),
  // onToggleSelect: () => dispatch(toggleSelectedItem('line', ownProps.line.id)),
  // onSelectRemove: () => dispatch(removeFromSelectedItems('line', ownProps.line.id)),
  onCreate: () => {
    const newLine = dispatch(createLine({ ...ownProps.line, text: '', id: undefined }));
    return dispatch(createLineGroup([ownProps.line.id, newLine.obj.id]));
  },
  onSelectAlt: (altLineId) => {
    dispatch(switchLineInSection(ownProps.section.id, ownProps.lineIndex, altLineId));
  },
});

const LineGroupsContainer = connect(mapStateToProps, mapDispatchToProps)(LineGroups);

export default LineGroupsContainer;



// WEBPACK FOOTER //
// ./src/containers/LineGroupsContainer.js